<ng-container>
    <div class="d-flex justify-content-between">
        <h2 class="text-center">Line Parameter</h2>
        <button mat-icon-button (click)="closeDialog()">
            <img src="assets/icons/close_material.svg" height="24"/>
        </button>
    </div>
    <div *ngIf="data">
        <!--   {{ data | json }} -->
        <div class="d-flex flex-column m-2">
            <span class="text-bg-danger ps-2">Name: {{ data.routeStation.name}} </span>
            <span class="text-center "> SAM ID: {{ data.routeStation.samId}} </span>
        </div>

        <div *ngFor="let kanal of data?.routeStation?.dataEndChannels">
            <!-- Typ + Sensortyp (via Radar-Verknüpfung) + Fahrspur zentral über getChannelLabel -->
            <div *ngIf="label(kanal) as lbl">
                <div class="d-flex bg-light m-2 border border-2 border-secondary">
                    <div class="d-flex justify-content-between bg-light m-2 w-100 align-items-center">
                        <div class="d-flex flex-column" style="max-width: 140px; overflow-wrap: anywhere;">
                            <span>{{ lbl.name }}</span>
                            <span *ngIf="lbl.sublabel">{{ lbl.sublabel }}</span>
                        </div>
                        <mat-form-field style="width: 100px">
                            <mat-label>Line</mat-label>
                            <div class="d-flex">
                                <input matInput type="number" [ngModel]="kanal.line" min="1" max="15"
                                    placeholder="Line" (ngModelChange)="modelChanged(kanal, $event)">

                                <button *ngIf=" kanal.line && kanal.line !== null" matSuffix mat-icon-button
                                    aria-label="Clear" (click)="deleteKanalsLineParam(kanal)">
                                    <img src="assets/icons/close_material.svg" height="24"/>
                                </button>
                            </div>
                        </mat-form-field>
                    </div>
                </div>
            </div>
        </div>
    </div>
</ng-container>
<mat-dialog-actions class="d-flex justify-content-end">
    <button class="btn btn-sm btn-outline-success rounded-0" (click)="submit()">Speichern</button>


</mat-dialog-actions>